var _style, _path, _path2, _path3, _path4, _path5, _path6, _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:5.5235;stroke-linecap:round;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.98,28.62L7.33,51.27C7.1,51.5,7.27,51.9,7.59,51.9h22.66c0.13,0,0.25-0.07,0.31-0.18l13.91-22.65 c0.15-0.25-0.03-0.56-0.31-0.56H30.24C30.14,28.52,30.05,28.56,29.98,28.62z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.52,28.62l22.65,22.65c0.23,0.23,0.07,0.63-0.26,0.63H70.25c-0.13,0-0.25-0.07-0.31-0.18L56.03,29.08 c-0.15-0.25,0.03-0.56,0.31-0.56h13.92C70.36,28.52,70.45,28.56,70.52,28.62z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.55,59.32L42.4,90.68c0.14,0.37-0.32,0.67-0.6,0.39L9.39,59.71c-0.24-0.23-0.07-0.63,0.26-0.63H30.2 C30.36,59.08,30.49,59.17,30.55,59.32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.14,59.32L58.29,90.68c-0.14,0.37,0.32,0.67,0.6,0.39L91.3,59.71c0.24-0.23,0.07-0.63-0.26-0.63H70.48 C70.33,59.08,70.19,59.17,70.14,59.32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.72,59.08h23.25c0.25,0,0.43,0.25,0.35,0.49L51.05,90.92c-0.12,0.32-0.57,0.33-0.69,0.01L38.38,59.58 C38.29,59.34,38.47,59.08,38.72,59.08z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.09,51.17L50.66,32.4c-0.14-0.25-0.5-0.25-0.64,0L39.24,51.16c-0.14,0.25,0.04,0.55,0.32,0.55h21.2 C61.04,51.72,61.22,51.41,61.09,51.17z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 50.34,
    y1: 9,
    x2: 50.34,
    y2: 20.78
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 79.42,
    y1: 12.04,
    x2: 72.81,
    y2: 21.79
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22,
    y1: 12.41,
    x2: 28.61,
    y2: 22.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenGem);
export default __webpack_public_path__ + "static/media/hidden-gem.95143ff495e7831910e87a1610cc5498.svg";
export { ForwardRef as ReactComponent };